import { useQuery } from 'react-query';
import { QueryId, STALE_TIME } from '@/integrations/content/utils';
import getCulture from '@/libraries/getters/get-culture';
import getLocale from '@/libraries/getters/get-locale';

type UseQuerySearchSettingsData = Content.Components['SearchSettingsDto'];

interface UseQuerySearchSettingsOptions {
  brand: Content.Properties.Brand;
  enabled?: boolean;
  initialData?: UseQuerySearchSettingsData;
}

const useQuerySearchSettings = ({
  brand,
  enabled = true,
  initialData,
}: UseQuerySearchSettingsOptions) => {
  const locale = getLocale();

  const query = useQuery<UseQuerySearchSettingsData>(
    [QueryId.SEARCH_SETTINGS, brand],
    async () => {
      const fetchResponse = await fetch(
        '/api/search-settings/search-settings',
        {
          headers: {
            ['Accept-Language']: getCulture(locale),
            ['Content-Type']: 'application/json',
            ...(brand && { ['X-Brand-Name']: brand }),
          },
          method: 'GET',
        },
      )
        .then(response => {
          if (response.ok) return response.json();

          throw new Error(`${response.status} - ${response.statusText}`);
        })
        .catch(error => {
          console.error('hooks.useQuerySearchSettings', error);

          throw error;
        });

      return fetchResponse;
    },
    {
      enabled: !!brand && enabled,
      initialData,
      keepPreviousData: true,
      staleTime: STALE_TIME,
    },
  );

  return query;
};

export default useQuerySearchSettings;
